package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.extensions.endsWithEmoji
import com.eladfinish.bible.contest.extensions.matches
import com.eladfinish.bible.contest.screens.search.model.Sign
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

class GetSpecialSignsUseCase {
    operator fun invoke(): ImmutableList<Sign> = listOf(
        "חיפוש תאריך - 📅",
        "חיפוש מספר - #",
        "גבול מילה - !",
        "אות אופציונלית - ?",
        "אות כלשהי - .",
        "אות כלשהי או רווח - ~",
        "אפס פעמים או יותר - *",
        "פעם אחת או יותר - +",
        "מילה כלשהי - _",
        "ראש פסוק - ^",
        "סוף פסוק - ׃",
        "סוגר עגול ימני - (",
        "סוגר עגול שמאלי - )",
        "סוגר מרובע ימני - [",
        "או - |",
        "סוגר מרובע שמאלי - ]",
        "סוגר מסולסל ימני - {",
        "סוגר מסולסל שמאלי - }",
        "אזכור לאחור - \\",

        "אתנחתא - א֑",
        "זקף קטן - א֔",
        "פסק - א׀",
        "מתג - אֽ",
        "זרקא - א֮",
        "סגולתא - א֒",
        "שלשלת - א֓",
        "זקף גדול - א֕",
        "מאריך - א֥",
        "טרחא - א֖",
        "רביע - א֗",
        "יתיב - א֚",
        "שופר מהופך - א֤",
        "קדמא - א֙",
        "שופר הולך - א֣",
        "פזר גדול - א֡",

        "שורש - √",
        "רפה - בֿ",
        "דגש - שּ",
        "שווא - שְ",
        "פתח - שַ",
        "קמץ - שָ",
//    "קמץ קטן - שׇ",
        "חיריק - שִ",
        "צירה - שֵ",
        "סגול - שֶ",
        "חולם - שֹ",
        "קובוץ - שֻ",
        "חטף פתח - שֲ",
        "חטף קמץ - שֳ",
        "חטף סגול - שֱ",
        "שין ימנית - שׁ",
        "שין שמאלית - שׂ",

        "מקף - ־",
        "קו אמצעי - -",
        "נ\' מנוזרת - ׆",

        "תלשא - א֠",
        "תילשא - א֩",
        "אזלא - א֨",
        "גריש - א֜",
        "גריש מוקדם - א֝",
        "שני גרישין - א֞",
        "קרני פרה - א֟",
        "תרי טעמי - א֦",
        "דרגא - א֧",
        "תביר - א֛",
        "ירח בן יומו - א֪",
        "עולה - א֫",
        "עילוי - א֬",
        "דחי - א֭",
        "צינורית - א֘",
        "נקודה עליונה - אׄ",
    ).map {
        Sign(
            value = it,
            display = it.takeLast(if (it.matches(regexString = ".* - [אבש].") || it.endsWithEmoji()) 2 else 1),
        )
    }.toImmutableList()
}
